var render = function render(_c,_vm){return _c('Tiles',_vm._l((_vm.props.items),function(item){return _c('Tile',{key:item.id,attrs:{"to":{name: 'artist', params: { id: item.id } },"title":item.name,"image":item.image},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('strong',[_vm._v(_vm._s(item.albumCount))]),_vm._v(" albums ")]},proxy:true}],null,true)})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }